const translations = {
  "referral.hero.title": "Refer other {client} fans and win exclusive perks.",
  "referral.hero.share.title": "Share your referral code",
  "referral.hero.share.copy": "Copy link",

  "referral.program.title": "The more you share, the more you earn.",
  "referral.program.subtitle": "Every referral that successfully joins the program counts as a successful referral, and you’ll earn your reward for it.",

  "referral.tracking.title": "Referrals Tracking",
  "referral.tracking.counter.label": "Referrals",

  "referral.list.status.approved": "Completed",
  "referral.list.status.pending": "Invited",
  "referral.list.status.denied": "Denied",

  "referral.list.empty": "You haven't referred anyone yet.",
  "referral.copy.success": "Referral link copied!",
};

export default translations;